import React, { useState } from "react";
import { videoPlayIcon } from "../../assets";
import {
  DataFilterComponent,
  Info,
  RedirectBtn,
  WatchTrailer,
  LauchTiming,
  TrasactionsNotificatios,
} from "../index";
import "./ContainerTool.css";

const Filters = ({ filtersState, chain, disabled }) => {
  const [expireModel, setExpireModel] = useState(false);
  const toggleVideoModal = (toggle) => {
    setExpireModel(toggle);
  };
  //Dodo need to update Cardno vido URL.
  const videoURL =
    chain == "CARDANO"
      ? process.env.VIDEO_LINK_CARDNAO ??
        "https://island-inventory.virtua.com/monsterzone/videos/buyland_monsterZone.mp4"
      : process.env.VIDEO_LINK_ETH ??
        "https://island-inventory.virtua.com/monsterzone/videos/buyland_monsterZone.mp4";

  return (
    <>
      <div className="top-Filters mt--100">
        <DataFilterComponent
          filtersState={filtersState}
          chain={chain}
          disabled={disabled}
        />
        <RedirectBtn />
        <div className="right-filter">
          <Info />
        </div>
      </div>

      <div className="bottom-section">
        <div className="grid">
          <div className="lunchTimerDiv">
            <LauchTiming />
          </div>
          <div className="grid-inner">
            <div className="videoTrailer">
              <button
                className="custom-btn icon-btn lg black-bg"
                onClick={toggleVideoModal}
              >
                <img src={videoPlayIcon} alt="video play" />
                <span className="btn-txt">How it Works?</span>
              </button>
            </div>
            <TrasactionsNotificatios chain={chain} />
          </div>
        </div>
      </div>
      <div>
        {expireModel && (
          <WatchTrailer
            open={expireModel}
            setOpen={toggleVideoModal}
            videoURL={videoURL}
          />
        )}
      </div>

      <div
        className="modal fade condoModalMobile"
        tabIndex="-1"
        role="dialog"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <div className="modal-dialog custom-modal modal-dialog-centered">
          <div className="modal-content">
            <div className="content">
              <h2>Attention!</h2>
              <p>This Condo Claim is only available on Desktop!</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Filters;
